// export const primaryColor = '#9774E1'
// export const secondaryColor = '#F03867'
import vue from 'vue'

 const colorConfig = {
   primaryColor: '#E20011',
   primarylightColor: '#F0F0A8',
   secondaryColor: '#F03867',
   tertiaryColor: '#D7CCF0',
   cakePrimaryColor: '#F03867',
   pinkColor: '#F03867',
   priceColor: '#DE1C24'
 }

// 注册颜色
vue.prototype.$colorConfig = colorConfig


export default colorConfig


